<template>
    <modal :show.sync=show :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Early Terminate Request</h3>

        <b-col cols="12" style="border-bottom: 2px solid #A4B0C0">
            <h3>Investor Detail</h3>
        </b-col>
        <b-row class="pt-3 px-3">
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Name</p>
                <p class="font-weight-500">Edward Jo</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Fund Name</p>
                <p class="font-weight-500">JV Fund 1.0-15%</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Fund Start Date</p>
                <p class="font-weight-500">27 Jul 2023</p>
            </b-col>
        </b-row>
        <b-row class="pb-3 px-3">
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Invested Amount</p>
                <p class="font-weight-500">RM {{ 64000 | moneyFormatter }}</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Fund Mature Date</p>
                <p class="font-weight-500">27 Jul 2025</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Remark</p>
                <p class="font-weight-500">Email Received on 8 Jun 2023 to w/draw</p>
            </b-col>
        </b-row>

        <b-col cols="12" style="border-bottom: 2px solid #A4B0C0">
            <h3>Fund Detail</h3>
        </b-col>
        <b-row class="pt-3 px-3">
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Total Payout on Interest</p>
                <p class="font-weight-500">RM {{ 9600 | moneyFormatter }}</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Withdraw TAT</p>
                <p class="font-weight-500">15 days</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Total Principal Withdrawal</p>
                <p class="font-weight-500">RM {{ 64000 | moneyFormatter }}</p>
            </b-col>
        </b-row>
        <b-row class="px-3">
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Total Profit Generate (%)</p>
                <p class="font-weight-500">7.5</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">(Extra) Pro Rate Calculation</p>
                <p class="font-weight-500">-</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Manual Adjustment (If available)</p>
                <b-form-input v-model="manual_adj" type="text" maxlength="2" @keydown="preventNonNumericInput"></b-form-input>
            </b-col>
        </b-row>
        <b-row class="px-3">
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Early Terminate Date</p>
                <p class="font-weight-500">12 Jan 2024</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Entitle Pro Rate Profit</p>
                <p class="font-weight-500">RM {{ 0 | moneyFormatter }}</p>
            </b-col>
        </b-row>
        <b-row class="pb-3 px-3">
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Approve Withdraw Date</p>
                <p class="font-weight-500">27 Jul 2023</p>
            </b-col>
            <b-col cols="auto" md="6">
                <p class="text-xs text-muted">Clawback Profit</p>
                <p class="font-weight-500">RM {{ 0 | moneyFormatter }}</p>
            </b-col>
        </b-row>
        <b-col cols="12" class="text-center">
            <el-button type="primary" class="w-50" @click="terminateReq()">Submit</el-button>
        </b-col>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Button } from 'element-ui'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
    props: {
        early_terminate: Boolean
    },
    components: {
        Modal,
        [Button.name]: Button,
    },
    data() {
        return {
            manual_adj: ''
        }
    },
    computed: {
        show: {
            get() {
                return this.early_terminate;
            },
            set(newVal) {
                this.$emit('update:early_terminate', newVal);
            },
        },
    },
    methods: {
        preventNonNumericInput,
        terminateReq() {
            swal.fire({
                title: 'Early Terminate Request',
                text: "Are you sure you want to early terminate this fund? This change requires Credit Manager's approval.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
            })
        }
    }
}
</script>